import { isNumeric } from '~/modules/common/numbers';

export const mapNumberValueOrDefault = (number, defaultValue = null) =>
  isNumeric(number) ? number : defaultValue;
